import { createUrlWithSearchParams } from '../url';

export const openInNewTab = (url: string) =>
    // eslint-disable-next-line no-restricted-syntax -- Только здесь и можно использовать window.open
    window.open(createUrlWithSearchParams(url), '_blank');
